var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "466C0039-B3CD-4AF2-BB1A-A2819845C330") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.775 0L0 8.7v2.9h27.55V8.7L13.775 0zM1.45 13.05v1.45c0 .797.653 1.45 1.45 1.45v7.25h4.35v-7.25c.797 0 1.45-.652 1.45-1.45v-1.45H1.45zm8.7 0v1.45c0 .797.652 1.45 1.45 1.45v7.25h4.35v-7.25c.797 0 1.45-.652 1.45-1.45v-1.45h-7.25zm8.7 0v1.45c0 .797.652 1.45 1.45 1.45v7.25h4.35v-7.25c.798 0 1.45-.652 1.45-1.45v-1.45h-7.25zM0 24.65V29h27.55v-4.35H0z",
    fill: "#DADADA",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrg);
export default __webpack_public_path__ + "static/media/org.1c40c4d18a218e2ffb74fd3f64f8f701.svg";
export { ForwardRef as ReactComponent };